import { takeEvery, put, fork, call } from 'redux-saga/effects';

import { Client } from 'utils/client';
import { REFUND_BATCH_GETTING, REFUND_BATCH_UPDATING, getRefundBatchConfigOnSuccess, getRefundBatchConfigOnFailed, updateRefundBatchConfigOnSuccess, updateRefundBatchConfigOnFailed } from './actions';

export function* getConfig() {
  try {
    const data = yield call(Client.getData, '/api/v1/batch/config');
    // const data = yield call(Client.getData, 'http://localhost:8095/api/v1/batch/portal/config');
    yield put(getRefundBatchConfigOnSuccess(data));
  } catch (error) {
    yield put(getRefundBatchConfigOnFailed(error))
  }
}

export function* updateConfig(action) {
  try {
    const data = action.payload;
    console.log("update config data: ", JSON.stringify(data))
    
    const response = yield call(Client.postData, '/api/v1/batch/config', data, true);
    // const response = yield call(Client.postData, 'http://localhost:8095/api/v1/batch/portal/config', data, true);
    yield put(updateRefundBatchConfigOnSuccess(response));
  } catch (error) {
    yield put(updateRefundBatchConfigOnFailed(error))
  }
}

function* watchOnLoad() {
  yield takeEvery(REFUND_BATCH_GETTING, getConfig);
  yield takeEvery(REFUND_BATCH_UPDATING, updateConfig);
}

export function* refundBatchConfigSaga() {
  yield fork(watchOnLoad);
}
